import "./about.css";
import FirstDiv from "../../components/aboutPage/firstdiv/FirstDiv";
import SecondDiv from "../../components/aboutPage/seconddiv/SecondDiv";
import ThirdDiv from "../../components/aboutPage/thirddiv/ThirdDiv";
import FourthDiv from "../../components/aboutPage/fourthdiv/FourthDiv";
import Footer from "../../components/footer/Footer";

export default function About() {
    return (
        <div className="about_page">
            <FirstDiv />
            <SecondDiv />
            <ThirdDiv />
            <FourthDiv />
            <Footer />
        </div>
    )
}
